<template>
  <thead>
    <tr class="cusmtom-thead-color">
      <td
        :rowspan="option === 'balanceVariablesByRibbon' ? 4 : 3"
        class="text-center p-3 custom-header-label"
      >
        {{ labelFirstCell }}
      </td>
    </tr>
    <tr class="cusmtom-thead-color">
      <td
        v-for="(ribbonData, week) in columns"
        :key="week"
        class="text-center p-3"
        :colspan="
          ribbonData.length * (option === 'balanceVariablesByRibbon' ? 5 : 2)
        "
      >
        <strong>{{ week }}</strong>
      </td>
    </tr>
    <tr>
      <template v-for="ribbonData in columns">
        <template v-for="ribbon in ribbonData">
          <td
            :colspan="option === 'balanceVariablesByRibbon' ? 5 : 1"
            class="text-center p-3"
            v-bind:style="getStyleCellRibbon(ribbon)"
          >
            {{ translateDataBaseText(ribbon.color_name, ribbon.other_values) }}
          </td>
          <td
            v-if="option !== 'balanceVariablesByRibbon'"
            class="text-center p-3"
          >
            %
          </td>
        </template>
      </template>
    </tr>
    <tr v-if="option === 'balanceVariablesByRibbon'">
      <template v-for="ribbonData in columns">
        <template v-for="ribbon in ribbonData">
          <td class="text-center p-3">{{ $t('production.bagged') }}</td>
          <td class="text-center p-3">{{ $t('production.harvested') }}</td>
          <td class="text-center p-3">
            {{ $t('production.plant_trimmed') }}
          </td>
          <td class="text-center p-3">{{ $t('common_words.balance') }}</td>
          <td class="text-center p-3">%</td>
        </template>
      </template>
    </tr>
  </thead>
</template>
<script>
import i18n from 'src/i18n';
import MixinTranslate from 'src/util/mixinTranslate';

export default {
  computed: {
    getLabel() {
      return this.labelFirstCell
        ? this.labelFirstCell
        : i18n.t('common_words.allotment');
    },
  },

  name: 'thead-ribbons-balances',
  mixins: [MixinTranslate],
  props: {
    labelFirstCell: {
      type: String,
      default: null,
    },
    columns: {
      type: Array | Object,
      default: [],
    },
    option: {
      type: String,
      default: 'ribbonsBalances',
    },
  },
  methods: {
    getStyleCellRibbon(row) {
      return (
        'background-color:' +
        row.color_code +
        ';color:' +
        row.color_text +
        '; font-weight: bold;'
      );
    },
  },
};
</script>
